import {IOfferStandardDescription} from "../../offer/detail/types/IOfferStandardDescription";
import {IParkingPlace} from "../../property/interfaces/IParkingPlace";
import {IPropertyListProperty} from "../../property/types/PropertyListProperty";
import {getPropertyBadgeType} from "../../property/utils/get_property_badge_type";
import {getAmplitudeViewItemEventProperties} from "./get_amplitude_view_item_event_properties";

type IAmplitudePropertyListItemValue = string | string[] | number | number[] | boolean | {type: number; area: number}[] | IParkingPlace[];

/**
 * Offer-level data shared by every property on the list. Kept structural so both the property detail offer
 * (`IPropertyDetailOffer`) and the offer detail one (`IOfferDetail`) can be passed in.
 */
export interface IAmplitudePropertyListMainOffer {
    facilities: number[] | null;
    parking_places: IParkingPlace[];
    standard_description: IOfferStandardDescription;
}

interface IGetAmplitudePropertyListItemParams {
    property: IPropertyListProperty;
    mainOffer: IAmplitudePropertyListMainOffer;
    index: number;
}

const getAmplitudePropertyPromotionLocation = (property: IPropertyListProperty): string | null => {
    if (property.is_promo) {
        return "Promocja";
    }

    return null;
};

export const getAmplitudePropertyListItem = ({
    property,
    mainOffer,
    index
}: IGetAmplitudePropertyListItemParams): Record<string, IAmplitudePropertyListItemValue> => {
    const promotionLocation = getAmplitudePropertyPromotionLocation(property);

    return {
        ...getAmplitudeViewItemEventProperties({
            offer: property.offer,
            property: {
                id: property.id,
                number: property.number,
                area: property.area,
                rooms: property.rooms,
                floor: property.floor,
                price: property.price
            }
        }),
        ...(property.price_m2 != null ? {price_m2: property.price_m2} : {}),
        ...(property.construction_end_date ? {available_from: property.construction_end_date} : {}),
        ...(property.additional_areas.length ? {additional_areas: property.additional_areas} : {}),
        ...(property.quarters.length ? {quarters: property.quarters} : {}),
        floors: property.floors,
        kitchen: property.kitchen_type,
        room_height_min: property.height_range.lower,
        room_height_max: property.height_range.upper,
        ...(mainOffer.facilities?.length ? {facilities: mainOffer.facilities} : {}),
        ...(mainOffer.parking_places.length ? {parking_places: mainOffer.parking_places} : {}),
        ...(mainOffer.standard_description.heating ? {heating: mainOffer.standard_description.heating} : {}),
        ...(mainOffer.standard_description.types.length ? {standard_types: mainOffer.standard_description.types} : {}),
        ...(promotionLocation ? {promotion_location: promotionLocation} : {}),
        rp_price_change_visible: getPropertyBadgeType(property) === "price_decreased",
        index
    };
};
import {IOfferStandardDescription} from "../../offer/detail/types/IOfferStandardDescription";
import {IParkingPlace} from "../../property/interfaces/IParkingPlace";
import {IPropertyListProperty} from "../../property/types/PropertyListProperty";
import {getPropertyBadgeType} from "../../property/utils/get_property_badge_type";
import {getAmplitudeViewItemEventProperties} from "./get_amplitude_view_item_event_properties";

type IAmplitudePropertyListItemValue = string | string[] | number | number[] | boolean | {type: number; area: number}[] | IParkingPlace[];

/**
 * Offer-level data shared by every property on the list. Kept structural so both the property detail offer
 * (`IPropertyDetailOffer`) and the offer detail one (`IOfferDetail`) can be passed in.
 */
export interface IAmplitudePropertyListMainOffer {
    facilities: number[] | null;
    parking_places: IParkingPlace[];
    standard_description: IOfferStandardDescription;
}

interface IGetAmplitudePropertyListItemParams {
    property: IPropertyListProperty;
    mainOffer: IAmplitudePropertyListMainOffer;
    index: number;
}

const getAmplitudePropertyPromotionLocation = (property: IPropertyListProperty): string | null => {
    if (property.is_promo) {
        return "Promocja";
    }

    return null;
};

export const getAmplitudePropertyListItem = ({
    property,
    mainOffer,
    index
}: IGetAmplitudePropertyListItemParams): Record<string, IAmplitudePropertyListItemValue> => {
    const promotionLocation = getAmplitudePropertyPromotionLocation(property);

    return {
        ...getAmplitudeViewItemEventProperties({
            offer: property.offer,
            property: {
                id: property.id,
                number: property.number,
                area: property.area,
                rooms: property.rooms,
                floor: property.floor,
                price: property.price
            }
        }),
        ...(property.price_m2 != null ? {price_m2: property.price_m2} : {}),
        ...(property.construction_end_date ? {available_from: property.construction_end_date} : {}),
        ...(property.additional_areas.length ? {additional_areas: property.additional_areas} : {}),
        ...(property.quarters.length ? {quarters: property.quarters} : {}),
        floors: property.floors,
        kitchen: property.kitchen_type,
        room_height_min: property.height_range.lower,
        room_height_max: property.height_range.upper,
        ...(mainOffer.facilities?.length ? {facilities: mainOffer.facilities} : {}),
        ...(mainOffer.parking_places.length ? {parking_places: mainOffer.parking_places} : {}),
        ...(mainOffer.standard_description.heating ? {heating: mainOffer.standard_description.heating} : {}),
        ...(mainOffer.standard_description.types.length ? {standard_types: mainOffer.standard_description.types} : {}),
        ...(promotionLocation ? {promotion_location: promotionLocation} : {}),
        rp_price_change_visible: getPropertyBadgeType(property) === "price_decreased",
        index
    };
};
